import React, { useState } from 'react';
import { BookOpen, ChevronLeft, ChevronRight, HelpCircle, PhoneCall, Rocket, Share2, Smartphone, X } from 'lucide-react';

// "How it Works" guide, ported from the DialFlow prototype.
const STEPS = [
  ['Welcome to the call flow builder', 'A call flow decides what happens when someone calls your company number: what they hear, which keys they can press, and who rings. Calls move through blocks along the lines that connect them.', BookOpen, 'var(--cyan-accent)', '6, 182, 212'],
  ['1. Add blocks', 'Drag blocks from the left onto the canvas, or click a block to add it. Every flow starts with one "Call Comes In" block, where you choose which of your numbers it answers.', PhoneCall, 'var(--violet-accent)', '139, 92, 246'],
  ['2. Connect them', 'Drag from a block\'s right dot to the next block\'s left dot. Menus, office hours, holidays and teams have several exits, one for each outcome.', Share2, 'var(--emerald-accent)', '16, 185, 129'],
  ['3. Test with the simulator', 'Click a block to change its settings on the right. Then use the phone simulator to walk through the flow: press keys, choose answered or not, and read the transcript. No real call is made.', Smartphone, 'var(--amber-accent)', '245, 158, 11'],
  ['4. Publish', 'Your changes save automatically as a draft. Real callers only hear the flow once you press Publish, and you can unpublish at any time to go back to standard routing.', Rocket, 'var(--pink-accent)', '236, 72, 153'],
];

export default function Guide({ buttonClassName = 'btn-floating-guide' }) {
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(0);
  if (!open) {
    return <button type="button" className={buttonClassName} onClick={() => { setOpen(true); setStep(0); }}><HelpCircle size={14} /><span>How it Works</span></button>;
  }
  const [title, text, Icon, color, rgb] = STEPS[step];
  return (
    <div className="guide-modal-overlay">
      <div className="guide-modal-card" role="dialog" aria-label="How call flows work">
        <button type="button" className="guide-modal-close" aria-label="Close" onClick={() => setOpen(false)}><X size={18} /></button>
        <div className="guide-modal-body">
          <div className="guide-step-indicator">
            {STEPS.map((_, i) => <span key={i} className={`step-dot ${i === step ? 'active' : ''}`} onClick={() => setStep(i)} />)}
          </div>
          <div className="guide-content-wrapper">
            <div className="guide-icon-box" style={{ backgroundColor: `rgba(${rgb}, 0.15)` }}><Icon size={32} style={{ color }} /></div>
            <h3>{title}</h3>
            <p>{text}</p>
          </div>
        </div>
        <div className="guide-modal-footer">
          <button type="button" className="btn-guide-nav" onClick={() => setStep(step - 1)} disabled={step === 0}><ChevronLeft size={16} /> Prev</button>
          {step === STEPS.length - 1
            ? <button type="button" className="btn-guide-finish" onClick={() => setOpen(false)}>Get Started</button>
            : <button type="button" className="btn-guide-nav" onClick={() => setStep(step + 1)}>Next <ChevronRight size={16} /></button>}
        </div>
      </div>
    </div>
  );
}
